import { createNode } from '@glueapp/graph-types';

export const NumberPrimitive = createNode({
    id: 'Number',
    name: 'Number',
    description: 'A Node for holding a number',
    aiDescription:
        'A primitive value node that holds a number. Set a default value on the "Number" input port; the "Number" output port passes it through.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        Number: { kind: 'number' },
    },
    execute: function (input) {
        return { output: { Number: input.inPorts.Number } };
    },
});
